import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/zoom";
import "../assets/styles/gallery.css";
import React, { useState } from "react";
import NavbarComponent from "../components/Navbar-component";
import SwiperComponent from "../components/Swiper-component";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBed, faBath, faUtensils, faCouch, faTree, faBorderAll } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const IMAGE_FILES = [
  { file: "letto1", category: "camere", key: "letto1" },
  { file: "letto2", category: "camere", key: "letto2" },
  { file: "letto3", category: "camere", key: "letto3" },
  { file: "letto4", category: "camere", key: "letto4" },
  { file: "camera1", category: "camere", key: "camera1" },
  { file: "bagno1", category: "bagni", key: "bagno1" },
  { file: "bagno2", category: "bagni", key: "bagno2" },
  { file: "bagno3", category: "bagni", key: "bagno3" },
  { file: "bagno4", category: "bagni", key: "bagno4" },
  { file: "cucina1", category: "cucina", key: "cucina1" },
  { file: "salone1", category: "salone", key: "salone1" },
  { file: "salone2", category: "salone", key: "salone2" },
  { file: "salone3", category: "salone", key: "salone3" },
  { file: "salone4", category: "salone", key: "salone4" },
  { file: "fuori1", category: "esterno", key: "fuori1" },
];

const CATEGORY_IDS = [
  { id: "all", icon: faBorderAll },
  { id: "camere", icon: faBed },
  { id: "bagni", icon: faBath },
  { id: "cucina", icon: faUtensils },
  { id: "salone", icon: faCouch },
  { id: "esterno", icon: faTree },
];

function Gallery() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState("all");

  const allImages = IMAGE_FILES.map((img) => ({
    ...img,
    label: t(`gallery.images.${img.key}.label`),
    desc: t(`gallery.images.${img.key}.desc`),
  }));

  const filtered = activeCategory === "all"
    ? allImages
    : allImages.filter((img) => img.category === activeCategory);

  return (
    <div className="gallery-page">

      {/* ── HERO ── */}
      <div className="gallery-hero">
        <div className="gallery-hero-overlay" />
        <div className="gallery-hero-nav">
          <NavbarComponent />
        </div>
        <div className="gallery-hero-content">
          <span className="gallery-eyebrow">{t('gallery.hero.eyebrow')}</span>
          <h1 className="gallery-title">{t('gallery.hero.title')}</h1>
          <p className="gallery-subtitle">
            {t('gallery.hero.subtitle')}
          </p>
        </div>
      </div>

      {/* ── STATS BAR ── */}
      <div className="gallery-stats-bar">
        <div className="gallery-stat">
          <span className="gstat-num">4</span>
          <span className="gstat-lbl">{t('gallery.stats.rooms')}</span>
        </div>
        <div className="gallery-stat-divider" />
        <div className="gallery-stat">
          <span className="gstat-num">4</span>
          <span className="gstat-lbl">{t('gallery.stats.bathrooms')}</span>
        </div>
        <div className="gallery-stat-divider" />
        <div className="gallery-stat">
          <span className="gstat-num">★ 4.9</span>
          <span className="gstat-lbl">{t('gallery.stats.rating')}</span>
        </div>
        <div className="gallery-stat-divider" />
        <div className="gallery-stat">
          <span className="gstat-num">15</span>
          <span className="gstat-lbl">{t('gallery.stats.photos')}</span>
        </div>
      </div>

      {/* ── FILTER TABS ── */}
      <div className="gallery-filters-section">
        <div className="gallery-filters">
          {CATEGORY_IDS.map((cat) => (
            <button
              key={cat.id}
              className={`filter-btn${activeCategory === cat.id ? " filter-btn--active" : ""}`}
              onClick={() => setActiveCategory(cat.id)}
            >
              <FontAwesomeIcon icon={cat.icon} />
              <span>{t(`gallery.categories.${cat.id}`)}</span>
            </button>
          ))}
        </div>
      </div>

      {/* ── CATEGORY DESCRIPTION ── */}
      <div className="gallery-category-desc">
        <h2>{t(`gallery.categoryDesc.${activeCategory}.title`)}</h2>
        <p>{t(`gallery.categoryDesc.${activeCategory}.text`)}</p>
        <span className="gallery-count">{t('gallery.photoCount', { count: filtered.length })}</span>
      </div>

      {/* ── SWIPER ── */}
      <div className="gallery-swiper-section">
        <SwiperComponent items={filtered} />
      </div>

      {/* ── CTA ── */}
      <div className="gallery-cta-bar">
        <p>{t('gallery.cta.text')}</p>
        <button onClick={() => navigate("/contatti")}>{t('gallery.cta.btn')}</button>
      </div>

    </div>
  );
}

export default Gallery;
